import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'noData',
  standalone: true,
})
export class NoDataPipe implements PipeTransform {

  transform(value: any, args?: any): any {
    return !value || value === 'Invalid date' ? args : value;
  }

}
